{
  "newActivityNotification": "การแจ้งเตือนกิจกรรมใหม่",
  "title": {
    "SELL_ORDER_PAIRED": "จับคู่คำสั่งซื้อแล้ว",
    "BUY_ORDER_PAIRED": "จับคู่คำสั่งซื้อแล้ว",
    "BUY_ORDER_UPLOAD_PAYMENT_PROOF": "ชำระเงินตามคำสั่งซื้อแล้ว",
    "SELL_ORDER_COMFIRMED_PAYMENT_PROOF": "ปล่อยเหรียญตามคำสั่งซื้อแล้ว",
    "BUY_ORDER_CANCELED": "ยกเลิกคำสั่งซื้อแล้ว",
    "BUY_ORDER_REQUEST_APPEAL_FROM_SELLER": "มีการยื่นอุทธรณ์คำสั่งซื้อ",
    "BUY_ORDER_REQUEST_APPEAL_FROM_BUYER": "มีการยื่นอุทธรณ์คำสั่งซื้อ",
    "SELL_ORDER_CHANGED_AMOUNT": "มีการขอแก้ไขคำสั่งซื้อ",
    "BUY_ORDER_AGREED_CHANGE_AMOUNT": "แก้ไขคำสั่งซื้อสำเร็จ",
    "BUY_ORDER_DISAGREED_CHANGE_AMOUNT": "แก้ไขคำสั่งซื้อไม่สำเร็จ",
    "SELL_ORDER_REQUEST_PAIR_CANCELED": "มีการขอยกเลิกคำสั่งซื้อ",
    "ADMIN_APPROVED_PAIR_CANCELED": "ยกเลิกคำสั่งซื้อสำเร็จ",
    "ADMIN_REJECTED_PAIR_CANCELED": "ยกเลิกคำสั่งซื้อไม่สำเร็จ",
    "ADMIN_FORCE_CANCELED_PAIR": "ฝ่ายสนับสนุนยกเลิกคำสั่งซื้อแล้ว",
    "ADMIN_FORCE_CANCELED_SELL_ORDER": "ฝ่ายสนับสนุนยกเลิกคำสั่งซื้อแล้ว",
    "ADMIN_FORCE_CANCELED_BUY_ORDER": "ฝ่ายสนับสนุนยกเลิกคำสั่งซื้อแล้ว",
    "ADMIN_FORCE_CONFIRMED": "ฝ่ายสนับสนุนปล่อยเหรียญแล้ว",
    "ADMIN_FORCE_CHANGED_AMOUNT": "ฝ่ายสนับสนุนแก้ไขและปล่อยเหรียญแล้ว",
    "USER_TRANSFERRED_PAYMENT_GATE_WAY": "การแจ้งเตือนการชำระเงิน",
    "USER_RECEIVED_CURRENCY": "การแจ้งเตือนรับเหรียญ",
    "USER_WITHDRAWAL_CURRENCY": "การแจ้งเตือนถอนเหรียญ",
    "USER_DEPOSIT_CURRENCY": "การแจ้งเตือนการชำระเงิน",
    "USER_EXCHANGE_IN": "การแจ้งเตือนการแลกเปลี่ยน",
    "USER_EXCHANGE_OUT": "การแจ้งเตือนการแลกเปลี่ยน",
    "USER_RECEIVED_EXCHANGE": "การแจ้งเตือนการแลกเปลี่ยน",
    "USER_RECEIVED_PAYOUT": "การแจ้งเตือนรับเหรียญ",
    "ADMIN_BUY_ORDER_CANCELED": "ยกเลิกคำสั่งซื้อสำเร็จ",
    "BUYER_BUY_ORDER_FORCE_CANCELED": "ยกเลิกคำสั่งซื้อแล้ว",
    "ADMIN_REJECT_KYC": "การยืนยันตัวตนไม่ผ่าน",
    "ADMIN_APPROVE_KYC": "การยืนยันตัวตนผ่านแล้ว",
    "BONUS_ACTIVITY_CREATED": "{{title}}"
  },
  "description": {
    "SELL_ORDER_PAIRED": "คำสั่งซื้อ {{orderId}} มีการจับคู่ใหม่ คำสั่งที่อยู่ระหว่างชำระเงินคือ {{subOrderId}} เราจะแจ้งให้ผู้ซื้อชำระเงินภายใน {{payTime}} นาที",
    "BUY_ORDER_PAIRED": "คำสั่งซื้อ {{orderId}} จับคู่แล้ว โปรดโอนเงินตามข้อมูลรับเงินของผู้ขายภายใน {{payTime}} นาที",
    "BUY_ORDER_UPLOAD_PAYMENT_PROOF": "ผู้ซื้อชำระเงินสำหรับคำสั่งซื้อ {{subOrderId}} แล้ว โปรดยืนยันการรับเงินและปล่อยเหรียญภายใน 10 นาที",
    "SELL_ORDER_COMFIRMED_PAYMENT_PROOF": "ผู้ขายปล่อยเหรียญสำหรับคำสั่งซื้อ {{orderId}} แล้ว",
    "BUY_ORDER_CANCELED": "ผู้ซื้อยกเลิกคำสั่งซื้อ {{subOrderId}} แล้ว",
    "BUY_ORDER_REQUEST_APPEAL_FROM_SELLER": "ผู้ขายยื่นอุทธรณ์คำสั่งซื้อ {{orderId}} แล้ว โปรดติดต่อฝ่ายสนับสนุน",
    "BUY_ORDER_REQUEST_APPEAL_FROM_BUYER": "ผู้ซื้อยื่นอุทธรณ์คำสั่งซื้อ {{subOrderId}} แล้ว โปรดติดต่อฝ่ายสนับสนุน",
    "SELL_ORDER_CHANGED_AMOUNT": "ผู้ขายขอแก้ไขจำนวนเงินสำหรับคำสั่งซื้อ {{orderId}} แล้ว โปรดตอบกลับคำขอแก้ไข",
    "BUY_ORDER_AGREED_CHANGE_AMOUNT": "ผู้ซื้อยอมรับการแก้ไขสำหรับคำสั่งซื้อ {{subOrderId}} แล้ว",
    "BUY_ORDER_DISAGREED_CHANGE_AMOUNT": "ผู้ซื้อปฏิเสธการแก้ไขสำหรับคำสั่งซื้อ {{subOrderId}} แล้ว คำสั่งซื้อกลับสู่สถานะรอปล่อยเหรียญ โปรดตรวจสอบรายละเอียด",
    "SELL_ORDER_REQUEST_PAIR_CANCELED": "ผู้ขายขอยกเลิกคำสั่งซื้อ {{id}} แล้ว โปรดรอฝ่ายสนับสนุนตอบกลับ",
    "ADMIN_APPROVED_PAIR_CANCELED": "คำขอยกเลิกคำสั่งซื้อ {{id}} ได้รับการอนุมัติแล้ว",
    "ADMIN_REJECTED_PAIR_CANCELED": "คำขอยกเลิกคำสั่งซื้อ {{id}} ถูกปฏิเสธและกลับสู่สถานะผู้ซื้อกำลังชำระเงิน โปรดตรวจสอบรายละเอียด",
    "ADMIN_FORCE_CANCELED_PAIR": "ฝ่ายสนับสนุนยกเลิกคำสั่งซื้อ {{orderId}} แล้ว",
    "ADMIN_FORCE_CANCELED_SELL_ORDER": "ฝ่ายสนับสนุนยกเลิกคำสั่งซื้อ {{orderId}} แล้ว",
    "ADMIN_FORCE_CANCELED_BUY_ORDER": "ฝ่ายสนับสนุนยกเลิกคำสั่งซื้อ {{id}} แล้ว",
    "ADMIN_FORCE_CONFIRMED": "ฝ่ายสนับสนุนปล่อยเหรียญสำหรับคำสั่งซื้อ {{id}} แล้ว",
    "ADMIN_FORCE_CHANGED_AMOUNT": "ฝ่ายสนับสนุนแก้ไขจำนวนเงินและปล่อยเหรียญสำหรับคำสั่งซื้อ {{id}} แล้ว",
    "USER_TRANSFERRED_PAYMENT_GATE_WAY": "จำนวนที่ชำระ {{amount}} {{token}}",
    "USER_RECEIVED_CURRENCY": "จำนวนเหรียญที่ได้รับ {{amount}} {{token}}",
    "USER_WITHDRAWAL_CURRENCY": "จำนวนเหรียญที่ถอน {{amount}} USDT",
    "USER_DEPOSIT_CURRENCY": "จำนวนที่ชำระ {{amount}} {{token}}",
    "USER_EXCHANGE_IN": "แลก {{relatedAmount}} USDT เป็น {{amount}} {{token}}",
    "USER_EXCHANGE_OUT": "แลก {{mount}} {{token}} เป็น {{amount}} USDT",
    "USER_RECEIVED_EXCHANGE": "แลก {{amountOut}} USDT ที่ได้รับเป็น {{amount}} {{token}} แล้ว",
    "USER_RECEIVED_PAYOUT": "จำนวนเหรียญที่ได้รับ {{amount}} {{token}}",
    "ADMIN_BUY_ORDER_CANCELED": "คำขอยกเลิกคำสั่งซื้อ {{orderId}} ได้รับการอนุมัติแล้ว",
    "BUYER_BUY_ORDER_FORCE_CANCELED": "ผู้ซื้อยกเลิกคำสั่งซื้อ {{subOrderId}} แล้ว",
    "ADMIN_REJECT_KYC": "ขออภัย การยืนยันตัวตนของคุณไม่ผ่าน โปรดดูรายละเอียดในแอป",
    "ADMIN_APPROVE_KYC": "ยินดีด้วย การยืนยันตัวตนของคุณผ่านแล้ว",
    "BONUS_ACTIVITY_CREATED": "{{description}}"
  }
}
